import { ReactElement } from "react";

import { ContentLocaleError } from "../ContentLocaleError/ContentLocaleError";

interface ContentGatedFooterProps {
  blocked: boolean;
  isStale: boolean;
  hasError: boolean;
  onRetry: () => void;
  children: (state: { isLoading: boolean; disabled: boolean }) => ReactElement;
}

/**
 * @param {boolean} blocked - disables the button and, while there's no error yet, shows its spinner
 * @param {boolean} isStale - whether what is on screen is not yet the requested locale's content
 * @param {boolean} hasError - whether the fetch has given up; gates the retry banner and suppresses
 *   the spinner, so a permanent failure reads as "stopped, here's why, retry" rather than "still
 *   working", and an in-flight re-fetch reads as loading rather than as a failure
 * @param {() => void} onRetry - wired to the banner's retry button
 * @param {(state: { isLoading: boolean; disabled: boolean }) => ReactElement} children - render prop
 *   for the Start/landing button, given the computed loading/disabled state to apply
 */
export function ContentGatedFooter({ blocked, isStale, hasError, onRetry, children }: ContentGatedFooterProps) {
  return (
    <>
      {isStale && hasError && <ContentLocaleError onRetry={onRetry} />}
      {children({ isLoading: blocked && !hasError, disabled: blocked })}
    </>
  );
}
